<template>
    <div class="igc-frame">
        <div class="ig--header">
            <div class="ig--close"
                :style="{ 'background-image': `url(${ imagePath }/${igEnv == 'development' ? 'test_' : ''}close.png)` }"
                @click="close"></div>
            <div class="ig--placeholder"></div>
            <div class="ig--search"
                v-if="config.search.length > 0"
                :style="{ 'background-image': `url(${ imagePath }/${igEnv == 'development' ? 'test_' : ''}search.png)` }"
                @click="toSearch"></div>

            <!-- #region 如果有“我的”模块，则右上角不提供个人中心入口 -->
            <div class="ig--avatar"
                v-if="tokenParams && !config.options.me"
                @click="toMe">
                <div class="ig--border"
                    :style="{ 'background-image': `url(${ imagePath }/avatar.png)` }"></div>
                <div class="ig--image"
                    v-if="userInfo.avatar"
                    :style="{ 'background-image': `url(${ userInfo.avatar })` }"></div>
            </div>
            <!-- #endregion -->
            
        </div>
        <div class="ig--container">
            <ul class="ig--navbar"
                :class="['ig--' + $route.name]">
                <li class="ig--navigator"
                    v-for="(item, key) in config.navigators"
                    v-if="config.options[key]"
                    :key="key"
                    :style="{ 'order': item.sort }"
                    @click="toModule(item, key)">
                    <div class="ig--redpoint"
                        v-if="key == 'me' && messageNum > 0"></div>
                </li>
            </ul>
            <div class="ig--wrapper">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import mBack from 'scripts/mixins/back'
import mCore from 'scripts/mixins/core'
import mPage from 'scripts/mixins/page'

export default {
    name: 'igc-frame',

    mixins: [mCore, mBack, mPage],

    data() {
        return {
            igEnv: sessionStorage.igEnv,
            tokenParams: sessionStorage.tokenParams,
        }
    },

    computed: {
        imagePath() {
            return this.$store.getters['global/imagePath']
        },

        config() {
            return this.$store.state.global.config
        },

        userInfo() {
            return this.$store.state.global.userInfo
        },

        messageNum() {
            return this.$store.state.me.messageNum
        },
    },

    methods: {
        close() {
            this.mEventTracking('topbar_close', '顶栏_关闭微社区')
            this.igClose()
        },

        toSearch() {
            this.mEventTracking('topbar_search', '顶栏_搜索')
            this.$router.push({
                name: 'search'
            })
        },

        toMe() {
            this.mEventTracking('topbar_usercenter', '顶栏_个人中心')
            this.$router.push({
                name: 'user'
            })
        },

        /**
         * 页面跳转
         * @param {Object} nav - 导航信息
         * @param {String} key - 导航键值
         */
        toModule(nav, key) {
            if (this.$route.name == key) {
                return
            }

            // #region 埋点
            let name = ''
            switch (key) {
                case 'index':
                    name = '导航_首页'
                    break
                case 'playbook':
                    name = '导航_攻略'
                    break
                case 'video':
                    name = '导航_视频'
                    break
                case 'webview':
                    name = '导航_发现'
                    break
                case 'bbs':
                    name = '导航_论坛'
                    break
                case 'qa':
                    name = '导航_问答'
                    break
                default:
                    name = '导航_其他'
                    break
            }
            this.mEventTracking('navbar_' + key, name)
            // #endregion

            if (nav.url && key != 'bbs') {

                // #region 外链 URL
                let url = nav.url
                if (sessionStorage.tokenParams) {
                    url = url.includes('?') ? url + sessionStorage.tokenParams.replace('?', '&') : url + sessionStorage.tokenParams
                }
                location.assign(url)
                // #endregion

            } else {

                // 路由跳转
                let route = {
                    name: key
                }
                if (nav.url) {
                    route.query = {
                        url: nav.url
                    }
                }
                this.$router.replace(route)
            }
        }
    }
}
</script>

<style lang="postcss">
.igc-frame {
    display: flex;
    flex-direction: column;
    height: 100%;
    > .ig--header {
        flex: none;
        display: flex;
        padding-right: 20px;
        background-repeat: no-repeat;
        @media (orientation: portrait) {
            height: 10.4vw;
            min-height: 78px;
            background-position: bottom;
            background-size: 100%;
        }
        @media (orientation: landscape) {
            height: 10.4vh;
            min-height: 4.8vw;
            background-position: center;
            background-size: auto 100%;
        }
        @media (max-aspect-ratio: 100/196) {
            padding-top: var(--safe-area-inset-top);
        }
        @media (min-aspect-ratio: 2/1) {
            padding-right: var(--safe-area-inset-right);
            padding-left: var(--safe-area-inset-left);
        }
        .ig--close {
            flex: none;
            background: no-repeat center / 100% 100%;
            @media (orientation: portrait) {
                width: 114px;
            }
            @media (orientation: landscape) {
                width: 15.2vh;
            }
        }
        .ig--placeholder {
            flex: auto;
        }
        .ig--search {
            width: 78px;
            background: no-repeat center / contain;
        }
        .ig--avatar {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 78px;
            .ig--border {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                z-index: 1;
                background: no-repeat center / 100% 100%;
            }
            .ig--image {
                width: 56px;
                height: 56px;
                border-radius: 50%;
                background: no-repeat center / cover;
            }
        }
    }
    > .ig--container {
        flex: auto;
        display: flex;
        overflow: hidden;
        @media (orientation: portrait) {
            flex-direction: column;
        }
        .ig--navbar {
            flex: none;
            display: flex;
            background-repeat: no-repeat;
            @media (orientation: portrait) {
                order: 2;
                height: 15.2vw;
                padding: 0 20px;
                background-position: top;
                background-size: 100%;
            }
            @media (orientation: landscape) {
                flex-direction: column;
                width: 15.2vh;
                background-position: right;
                background-size: auto 100%;
            }
            @media (max-aspect-ratio: 1/2) {
                padding-bottom: var(--safe-area-inset-bottom);
            }
            @media (min-aspect-ratio: 2/1) {
                padding-left: var(--safe-area-inset-left);
            }
            .ig--navigator {
                flex: auto;
                position: relative;
                .ig--redpoint {
                    position: absolute;
                    top: 15%;
                    right: 15%;
                    width: 12px;
                    height: 12px;
                    border-radius: 50%;
                    background: #f43530;
                }
            }
        }
        .ig--wrapper {
            flex: auto;
            position: relative;
            display: flex;
            flex-direction: column;
            overflow: hidden;
        }
    }
}
</style>